__turbopack_context__.v({
  "className": "inter_b2991b2-module__9mH_6q__className",
  "variable": "inter_b2991b2-module__9mH_6q__variable",
});
